import { InputNumber } from "antd";
import styled from "styled-components";

import colors from "constants/palette";

const Container = styled.div`
  margin-top: 12px;
  & .ant-input-number {
    background-color: ${colors.white + "40"} !important;
    color: ${colors.dark};
  }
`;

export default function numberInput(props) {
  return (
    <Container>
      <InputNumber
        {...props}
        size="large"
        addonAfter={props?.currency ? "تومان" : null}
      />
    </Container>
  );
}
